import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["prepaidFields", "recurringFields", "amountHint"];

  change(event) {
    this.toggle(event.target.value);
  }

  connect() {
    const initial = this.element.dataset.addOnKindInitialValue;
    if (initial) {
      this.toggle(initial);
    }
  }

  toggle(kind) {
    const showPrepaid = kind === "one_off_prepaid";
    const showRecurring = kind === "recurring";

    if (this.hasPrepaidFieldsTarget) {
      this.prepaidFieldsTarget.classList.toggle("hidden", !showPrepaid);
    }

    if (this.hasRecurringFieldsTarget) {
      this.recurringFieldsTarget.classList.toggle("hidden", !showRecurring);
    }

    if (this.hasAmountHintTarget) {
      if (showPrepaid) {
        this.amountHintTarget.textContent =
          "The monthly rate. Total will be calculated as rate × months.";
      } else if (showRecurring) {
        this.amountHintTarget.textContent =
          "The amount charged each billing interval.";
      } else {
        this.amountHintTarget.textContent = "The total amount for this charge.";
      }
    }
  }
}
